import { usePostApiAdminProvisionTest } from '@sit/client-shared';
import Button from 'carbon-react/lib/components/button';
import Loader from 'carbon-react/lib/components/loader';
import type { FormEventHandler } from 'react';
import MissingPermissions from '../../MissingPermissions/MissingPermissions';

interface CheckCompanyPermissionsProps {
  intacctCompanyId: string;
  companyTreeSettingsId: number;
}

export function CheckCompanyPermissions({
  intacctCompanyId,
  companyTreeSettingsId,
}: CheckCompanyPermissionsProps) {
  const {
    mutate: checkPermissions,
    isPending,
    data,
  } = usePostApiAdminProvisionTest();

  const handleSubmit: FormEventHandler<Element> = (e) => {
    e.preventDefault();
    if (isPending) return;
    checkPermissions({
      body: {
        companyId: intacctCompanyId,
      },
      queryParams: {
        keepAlive: 'true',
      },
    });
  };

  return (
    <>
      <Button onClick={handleSubmit}>
        {isPending ? <Loader isInsideButton /> : 'Check'}
      </Button>
      {data?.missingPermissions ? (
        data.missingPermissions.length > 0 ? (
          <MissingPermissions
            missing={data.missingPermissions}
            companyTreeSettingsId={companyTreeSettingsId}
          />
        ) : (
          <div>The WSU has all required permissions</div>
        )
      ) : null}
    </>
  );
}
